import React from 'react';

import Header from 'components/SocialSurvey/Issue/Header';

const Item = ({ data }) => {
  return (
    <>
      <Header layout="col" data={data} />
    </>
  );
};

export default Item;
